import { FeaturedCitiesPicker } from "@/components/admin/FeaturedCitiesPicker";
import { CityQuotesQueue } from "@/components/admin/CityQuotesQueue";
import { FeaturedFirmsPicker } from "@/components/admin/FeaturedFirmsPicker";

export default function AdminFeaturedCities() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 space-y-8" data-testid="admin-featured-cities-page">
      <div>
        <h1 className="text-3xl font-semibold text-stone-900">Featured cities, subjects &amp; firms</h1>
        <p className="text-sm text-stone-600 mt-2">Choose the cities that rotate on the homepage and approve the student quotes shown with them.</p>
      </div>
      <FeaturedCitiesPicker />
      <FeaturedCitiesPicker endpoint="/admin/featured-subjects" heading="Homepage featured subjects" placeholder="Add a subject: type a name…" tid="featured-subjects-picker" />
      <FeaturedFirmsPicker />
      <CityQuotesQueue />
    </div>
  );
}
